import { useSearch } from "@tanstack/react-router";
import { useGetOutgoingPostbackQuery } from "api/TenantSlug/OutgoingPostback/hooks.ts";
import { ModifyPostbackOutgoingForm } from "components/Forms/ModifyPostbackOutgoingForm/ModifyPostbackOutgoingForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`modifyOutgoingPostback-id`]: string;
}

export const ModifyPostbackOutgoingDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.modify-postback-outgoing");
    const drawerId = DrawerId.ModifyOutgoingPostback;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const outgoingPostbackId = searchParams[`${drawerId}-id`];
    const getOutgoingPostbackQuery = useGetOutgoingPostbackQuery(outgoingPostbackId, {});

    if (
        getOutgoingPostbackQuery.isLoading ||
        getOutgoingPostbackQuery.isFetching ||
        !getOutgoingPostbackQuery.data?.outgoingPostback
    ) {
        return <></>;
    }
    const outgoingPostback = getOutgoingPostbackQuery.data.outgoingPostback;

    return (
        <Drawer drawerId={drawerId} title={<DrawerTitle mainTitle={t("title")} subTitles={[outgoingPostback.name]} />}>
            <ModifyPostbackOutgoingForm
                onClose={() => drawerUtils.hide(drawerId)}
                outgoingPostback={outgoingPostback}
            />
        </Drawer>
    );
};
